import { useLanguageStore } from '../index';
import { zhData } from './zh';
import { DataTranslationType } from './types';

export function useDataTranslation() {
  const language = useLanguageStore((s) => s.language);

  const tData = (
    type: DataTranslationType,
    id: string | number,
    field: string,
    fallback: string,
  ): string => {
    if (language === 'en') return fallback;
    return zhData[type]?.[String(id)]?.[field] ?? fallback;
  };

  return { tData };
}
